import ReactDOM from 'react-dom';
import UPshowState from '../UPshowState';
import StateFactory from '../StateFactory';
import { getModelConfig } from '../../utils/models';
import '../../index.scss'

function Inactive () {
    const {contact, phone, email } = getModelConfig().inactiveState;

    return (
        <div className="EverpassInactive">
            <div className='content'>
                <div>
                    <div className="first">
                        {contact}
                        <br />
                        to reactivate your device
                    </div>
                    <div className="second">
                        <p>{phone}</p>
                        <p>{email}</p>
                    </div>
                </div>
                <div className="logo">
                    <img
                        alt="logo"
                        src="https://cdn.upshow.tv/ui-assets/EverPass_Horizontal_on_Black_Transparent.png"
                    />
                </div>
            </div>
        </div>
    );
}

class InactiveState extends UPshowState {

    get name () {
        return 'inactive';
    }

    preload () {
        ReactDOM.render(<Inactive/>, this.node);

        return super.preload();
    }
}

StateFactory.register('inactive', InactiveState, 10);

export default InactiveState;
